module.exports = __webpack_public_path__ + "fonts/iconfont.f95e121c.ttf";